export default "/images/552a0417736901294c99dc806948dbfe.avif";